import request from "@/utils/request";

function touristsBehaviorGetGenderAndAgeRate(data) {     // 性别年龄占比
    return request({
        url: "/touristsBehavior/getGenderAndAgeRate",
        method:"POST",
        data
    })
}

function touristsBehaviorGetEducationAndJobRate(data) {   // 学历职业占比
    return request({
        url: "touristsBehavior/getEducationAndJobRate",
        method:"POST",
        data
    })
}

function touristsBehaviorGetConsumeFreedom(data) {   //消费自由度 综合收入水平 综合消费水平
    return request({
        url: "/touristsBehavior/getConsumeFreedom",
        method:"POST",
        data
    })
}

function touristsBehaviorGetServiceAndBrandRate(data) {       //运营商手机品牌
    return request({
        url: "/touristsBehavior/getServiceAndBrandRate",
        method:"POST",
        data
    })
}

function touristsBehaviorGetMarriageAndChildRate(data) {     // 是否大学生婚姻子女阶段
    return request({
        url: "touristsBehavior/getMarriageAndChildRate",
        method:"POST",
        data
    })
}

function touristsBehaviorGetConsumeGradeAndCarRate(data){   // 消费品级有车比列
    return request({
        url: "touristsBehavior/getConsumeGradeAndCarRate",
        method:"POST",
        data
    })
}

function travelPerformanceGetTravelSatisfaction(data) {   // 旅游满意度
    return request({
        url: "/travelPerformance/getTravelSatisfaction",
        method:"POST",
        data
    })
}

function travelPerformanceGetActiveCityTop20(data) {  //游客活跃城市TOP20
    return request({
        url: "/travelPerformance/getActiveCityTop20",
        method:"POST",
        data
    })
}

function travelPerformanceGetTransportationRate(data) {    // 出行方式偏好
    return request({
        url: "/travelPerformance/getTransportationRate",
        method:"POST",
        data
    })
}

function travelPerformanceGetCateringTop10(data) {   // 餐饮类型偏好
    return request({
        url: "/travelPerformance/getCateringTop10",
        method:"POST",
        data
    })
}


function travelPerformanceGetHotelTop10(data) {    // 酒店类型偏好酒店品牌
    return request({
        url: "/travelPerformance/getHotelTop10",
        method:"POST",
        data
    })
}

function appPerformanceGetAppUseFrequenceAndTime(data){   // 应用时长使用频率
    return request({
        url: "/appPerformance/getAppUseFrequenceAndTime",
        method:"POST",
        data
    })
}

function appPerformanceGetAppTypeList(data){   //获取APP类型列表
    return request({
        url: "/appPerformance/getAppTypeList",
        method:"POST",
        data
    })
}

function   appPerformanceGetAppList(data){      //APP旅游偏好 16个分类
    return request({
        url: "/appPerformance/getAppList",
        method:"POST",
        data
    })
}

function appPerformanceGetAppInstallTop(data){   //APP安装TOP10 20
    return request({
        url: "/appPerformance/getAppInstallTop",
        method:"POST",
        data
    })
}

export {
    touristsBehaviorGetGenderAndAgeRate,
    touristsBehaviorGetEducationAndJobRate,
    touristsBehaviorGetConsumeFreedom,
    touristsBehaviorGetServiceAndBrandRate,
    touristsBehaviorGetMarriageAndChildRate,
    touristsBehaviorGetConsumeGradeAndCarRate,
    travelPerformanceGetActiveCityTop20,
    travelPerformanceGetTransportationRate,
    travelPerformanceGetTravelSatisfaction,
    travelPerformanceGetCateringTop10,
    travelPerformanceGetHotelTop10,
    appPerformanceGetAppUseFrequenceAndTime,
    appPerformanceGetAppTypeList,
    appPerformanceGetAppList,
    appPerformanceGetAppInstallTop
}
